import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-left\"><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M8.5 7.5l-4 4 4 4m-3.5-4h15\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol